import { localStorage } from '../../../../../shared/localstorage';
import { WebCategory } from '../../../../../domain/model/category/WebCategory';
import { WebSubCategory } from '../../../../../domain/model/category/WebSubCategory';

interface Keyword {
  readonly keyword: string;
  readonly link: string;
  readonly category: WebCategory;
  readonly subCategory: WebSubCategory;
  readonly isTrendingRapidly: boolean;
}

type CommentTimelineKeywordsState = ReadonlyArray<Keyword>;

export interface CommentTimelineModuleState {
  /** 誘導用モジュールを表示するかどうか */
  isBalloonVisible?: boolean;
  keywords: CommentTimelineKeywordsState;
  canWebToApp: boolean;
  updatedTime: string;
}

const ActionType = {
  INITIALIZE_BALLOON: 'commentTimelineKeywords/INITIALIZE_BALLOON',
  HIDE_BALLOON: 'commentTimelineKeywords/HIDE_BALLOON'
} as const;

type Actions = { type: typeof ActionType.INITIALIZE_BALLOON } | { type: typeof ActionType.HIDE_BALLOON };

export const reflectLocalStorage: Actions = {
  type: ActionType.INITIALIZE_BALLOON
} as const;

export const hideBalloon: Actions = {
  type: ActionType.HIDE_BALLOON
} as const;

const initialState: CommentTimelineModuleState = {
  isBalloonVisible: false,
  keywords: [],
  canWebToApp: false,
  updatedTime: ''
};

const LOCALSTORAGE_KEY_COMMENT_TIMELINE_BALLOON = 'YAHOO.JP.News.Top.commenttimeline.balloon' as const;
const LOCALSTORAGE_VER_COMMENT_TIMELINE_BALLOON = 1 as const;

export default (state: CommentTimelineModuleState = initialState, action: Actions) => {
  switch (action.type) {
    case ActionType.INITIALIZE_BALLOON: {
      const balloonStorage = localStorage.get<{ isVisible: boolean }>(
        LOCALSTORAGE_KEY_COMMENT_TIMELINE_BALLOON,
        LOCALSTORAGE_VER_COMMENT_TIMELINE_BALLOON
      );

      return {
        ...state,
        isBalloonVisible: balloonStorage?.isVisible ?? true
      };
    }
    case ActionType.HIDE_BALLOON:
      localStorage.set<{ isVisible: boolean }>(
        LOCALSTORAGE_KEY_COMMENT_TIMELINE_BALLOON,
        LOCALSTORAGE_VER_COMMENT_TIMELINE_BALLOON,
        {
          isVisible: false
        }
      );
      return {
        ...state,
        isBalloonVisible: false
      };
    default:
      return state;
  }
};
